'use strict';

const $ = window.jQuery;

export default function () {
    $(document).on( 'frmFormComplete', function( event, form, response ) {
        var formID = $(form).find('input[name="form_id"]').val();

        if( formID == 4 && response.errors.length == 0) {

            $('[data-back-btn]').appendTo(".frm_message");
            $('[data-back-btn] .btn').removeClass('btn--hidden');
        }
    });

    if($('input[type="hidden"][value="adherent"]').length > 0) {
        let emailInput = $('input[type="hidden"][value="adherent"]');

        let id_company = $('[data-id-company]').data('id-company');

        if(id_company != "") {
            let url = document.location.origin  + "/wp-json/sn/adherent/one?id_company=" + id_company;

            $.ajax({
                url: url,
                success: function(result) {
                    emailInput.val(result.email);
                },
            });
        }
    }
}
